module.exports = __webpack_public_path__ + "img/viadeo-square.966af552.svg";